import(/* webpackMode: "eager", webpackExports: ["Home"] */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/Home.tsx");
